/**
 * Platform-specific configuration for OAuth onboarding
 * Used by DynamicPlatformOnboarding and PlatformAuthForm
 */

export const PLATFORM_CONFIG = {
  tiktok: {
    displayName: 'TikTok Ads',
    description:
      'Connect your TikTok Ads account to sync campaigns and performance data.',
    requirements: [
      'TikTok For Business login',
      'Access to the TikTok ad account',
      'Permission to authorize account access',
    ],
    capabilities: [
      'Campaign performance reporting',
      'Ad spend and metrics tracking',
      'Creative performance insights',
      'Audience analytics',
    ],
  },

  google: {
    displayName: 'Google Ads',
    description:
      'Connect your Google Ads account to sync campaigns, keywords, and performance data.',
    requirements: [
      'Google account',
      'Access to the Google Ads account',
      'Permission to manage the requested advertising data',
    ],
    capabilities: [
      'Campaign and ad group reporting',
      'Keyword performance tracking',
      'Conversion tracking',
      'Search query insights',
      'Budget and spend analytics',
    ],
  },

  meta: {
    displayName: 'Meta Advertising',
    description:
      'Connect your Meta ad account to sync Facebook and Instagram campaigns and performance data.',
    requirements: [
      'Facebook account',
      'Access to the Meta ad account',
      'Permission to manage campaigns or view performance data',
    ],
    capabilities: [
      'Campaign performance reporting',
      'Ad creative insights',
      'Audience targeting analytics',
      'Conversion tracking',
      'Facebook and Instagram reporting',
    ],
  },

  microsoft: {
    displayName: 'Microsoft Advertising',
    description:
      'Connect your Microsoft Advertising account to sync campaigns and performance data.',
    requirements: [
      'Microsoft account',
      'Access to the Microsoft Advertising account',
      'Permission to manage the requested advertising data',
    ],
    capabilities: [
      'Campaign and ad group reporting',
      'Keyword performance tracking',
      'Search advertising analytics',
      'Conversion tracking',
      'Budget and spend insights',
    ],
  },

  'criteo-target': {
    displayName: 'Target Roundel (via Criteo)',
    description:
      'Authorize Limitless through Criteo to create, manage, and report on Target Roundel campaigns.',
    requirements: [
      'Criteo account linked to your Target advertiser portfolio',
      'Access to the Target portfolio in Criteo',
      'Admin, Business Manager, or Technical Manager role',
    ],
    capabilities: [
      'Campaign creation and management',
      'Campaign performance reporting',
      'Ad spend and metrics tracking',
      'ROAS and conversion tracking',
      'Online and in-store sales reporting',
    ],
  },
};
/**
 * Get platform configuration by key
 * @param {string} adPlatform - Platform key (e.g., 'tiktok', 'google')
 * @returns {object|null} Platform config or null if not found
 */
export const getPlatformConfig = (adPlatform) => {
  if (!adPlatform) return null;
  return PLATFORM_CONFIG[adPlatform.toLowerCase()] || null;
};
